import { SKIP_SECONDS } from "../consts"

type SkipDirection = "back" | "forward"

type SkipMediaByOptions = {
  begin?: number | null
  end?: number | null
  seconds?: number
}

export default function skipMediaBy(
  element: HTMLMediaElement,
  direction: SkipDirection,
  options: SkipMediaByOptions = {}
) {
  const seconds = options.seconds ?? SKIP_SECONDS
  const delta = direction === "back" ? -seconds : seconds
  const minTime = options.begin ?? 0
  const maxTime = options.end ?? element.duration ?? Infinity
  element.currentTime = Math.min(
    maxTime,
    Math.max(minTime, element.currentTime + delta)
  )
}
